import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface FilterCheckboxGroupProps {
  options: string[];
  selected: string[];
  emptyLabel: string;
  onToggle: (value: string, checked: boolean) => void;
  formatLabel?: (value: string) => string;
}

/** The repeated body of every facet section. */
const FilterCheckboxGroup: React.FC<FilterCheckboxGroupProps> = ({
  options,
  selected,
  emptyLabel,
  onToggle,
  formatLabel,
}) => {
  if (options.length === 0) {
    return <p className="revy-cjk py-1 text-xs leading-[1.6] text-muted-foreground">{emptyLabel}</p>;
  }

  return (
    <div className="flex max-h-56 flex-col gap-2 overflow-y-auto">
      {options.map((option) => (
        <div key={option} className="flex items-center gap-2">
          <Checkbox
            id={`facet-${option}`}
            checked={selected.includes(option)}
            onCheckedChange={(checked) => onToggle(option, checked === true)}
          />
          <Label
            htmlFor={`facet-${option}`}
            className="revy-cjk cursor-pointer text-sm font-normal leading-[1.5]"
          >
            {formatLabel ? formatLabel(option) : option}
          </Label>
        </div>
      ))}
    </div>
  );
};

export default FilterCheckboxGroup;
